import { toast } from "sonner";

/**
 * Native share button — uses Web Share API on mobile, falls back to clipboard copy.
 * Only visible on mobile (< 768px).
 *
 * Usage: <ShareButton title="EFL Account" text="Check out this account" />
 */
export default function ShareButton({ title, text, url }) {
  const shareUrl = url || window.location.href;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: title || "Dentsu AMP", text: text || "", url: shareUrl });
      } catch (e) {
        if (e.name !== "AbortError") toast.error("Share failed");
      }
    } else {
      // Fallback: copy link
      try {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied!");
      } catch {
        toast.error("Couldn't copy link");
      }
    }
  };

  // Only show on mobile
  if (typeof window !== "undefined" && window.innerWidth > 768) return null;

  return (
    <button
      onClick={handleShare}
      style={{
        background: "var(--s2)",
        border: "1px solid var(--bdr)",
        borderRadius: 8,
        padding: "8px 14px",
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        color: "var(--t2)",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 6,
        letterSpacing: ".04em",
      }}
      title="Share"
    >
      <span style={{ fontSize: 14 }}>↗</span> Share
    </button>
  );
}
